import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { DatasetAndSync } from "@dashboard-v3/api";
import SyncRunError from "../Sync/SyncRunError";

/**
 * Por que fallo el ultimo sync, al abrir el item de la lista (MXH-5792).
 *
 * Es el mismo `SyncRunError` del detalle del dataset, a proposito: el caso mas
 * comun -una cuenta de cloud storage que hay que reautorizar- se resuelve desde
 * el alert que ese componente ya trae, sin entrar al dataset. El badge del
 * header dice que algo se rompio; esto dice que.
 *
 * `WAITING_RETRY` tambien lo muestra: el run fallo y el motivo es el mismo que
 * va a hacer fallar los reintentos. Verlo antes evita esperar diez rondas para
 * enterarse de que la credencial esta vencida.
 */
export default function LastRunError({
  lastRun,
}: Pick<DatasetAndSync, "lastRun">) {
  const { t } = useTranslation("datasets");

  if (!lastRun) return null;

  const failed =
    lastRun.status === "ERROR" ||
    lastRun.status === "WAITING_RETRY_CANCELED" ||
    lastRun.status === "WAITING_RETRY";

  if (!failed) return null;

  return (
    <Box
      mb={1}
      p={2}
      border="1px solid #e5e5e5"
      borderRadius={5}
      data-testid="datasets_last-run-error"
    >
      <Typography style={{ fontWeight: 500 }}>
        {t("listItem.lastSyncFailed", {
          defaultValue: "The last synchronization failed",
        })}
      </Typography>
      <SyncRunError
        error={lastRun.error}
        errorCode={lastRun.errorCode}
        errorDescription={lastRun.errorDescription}
      />
    </Box>
  );
}
